<template>
    <div>
        <invoice :invoiceOrigin="invoiceOrigin" :invoiceOriginLabel="'Cliente'"></invoice>
    </div>
</template>

<script>
    import Invoice from '../invoice/Invoice';
    import {InvoiceOrigin} from "../../config";
    export default {
        data(){
            return {
                invoiceOrigin: InvoiceOrigin.SellInvoices,
            }
        },

        components:{
            Invoice,
        }
    }
</script>

<style scoped>

</style>